import { render } from "./RecommendedDonors.vue?vue&type=template&id=0addacea&scoped=true&ts=true"
import script from "./RecommendedDonors.vue?vue&type=script&lang=ts"
export * from "./RecommendedDonors.vue?vue&type=script&lang=ts"

import "./RecommendedDonors.vue?vue&type=style&index=0&id=0addacea&scoped=true&lang=css"
import "./RecommendedDonors.vue?vue&type=style&index=1&id=0addacea&lang=css"

import exportComponent from "d:\\jenkins-nodes\\Atlanta\\workspace\\atlanta-fe-git\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0addacea"]])

export default __exports__